document.addEventListener('DOMContentLoaded', function() {
  var style = document.createElement('style');
  style.innerHTML = `
    #whatsapp-float-btn {
      position: fixed !important;
      bottom: 28px !important;
      right: 28px !important;
      z-index: 99999 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 58px !important;
      height: 58px !important;
      border-radius: 50% !important;
      background-color: #25D366 !important;
      box-shadow: 0 4px 16px rgba(37,211,102,0.45), 0 2px 6px rgba(0,0,0,0.18) !important;
      text-decoration: none !important;
      transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.4s ease, visibility 0.4s ease !important;
      opacity: 0 !important;
      visibility: hidden !important;
    }
    #whatsapp-float-btn.visible {
      opacity: 1 !important;
      visibility: visible !important;
    }
    #whatsapp-float-btn:hover {
      transform: scale(1.1) !important;
    }
    #whatsapp-float-btn::before {
      content: '';
      position: absolute;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      background-color: rgba(37,211,102,0.4);
      animation: whatsapp-pulse 2s ease-out infinite;
    }
    @keyframes whatsapp-pulse {
      0%   { transform: scale(1);   opacity: 0.7; }
      70%  { transform: scale(1.6); opacity: 0; }
      100% { transform: scale(1.6); opacity: 0; }
    }
    #whatsapp-float-btn svg {
      width: 28px !important;
      height: 28px !important;
      position: relative;
      z-index: 1;
      flex-shrink: 0;
    }
    #whatsapp-float-btn .whatsapp-tooltip {
      position: absolute !important;
      right: 68px !important;
      background: #1a1a1a !important;
      color: #fff !important;
      font-size: 13px !important;
      font-family: sans-serif !important;
      padding: 6px 12px !important;
      border-radius: 6px !important;
      white-space: nowrap !important;
      opacity: 0 !important;
      pointer-events: none !important;
      transition: opacity 0.2s ease !important;
    }
    #whatsapp-float-btn:hover .whatsapp-tooltip {
      opacity: 1 !important;
    }
  `;
  document.head.appendChild(style);

  var btn = document.createElement('a');
  btn.id = 'whatsapp-float-btn';
  btn.href = 'https://wa.me/916296322290?text=Hi%2C%20I%20came%20across%20your%20website%20can%20you%20please%20help%20me?';
  btn.target = '_blank';
  btn.rel = 'noopener noreferrer';
  btn.setAttribute('aria-label', 'Chat on WhatsApp');
  btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" width="28" height="28">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
    </svg>
    <span class="whatsapp-tooltip">Chat with us!</span>
  `;
  document.body.appendChild(btn);

  // Show button only when footer is visible
  var footer = document.querySelector('footer') || document.querySelector('.footer') || document.querySelector('#footer');

  if (footer) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          btn.classList.add('visible');
        } else {
          btn.classList.remove('visible');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(footer);
  } else {
    // Fallback: show after 80% scroll if footer element not found
    window.addEventListener('scroll', function() {
      var scrolled = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
      if (scrolled > 0.8) {
        btn.classList.add('visible');
      } else {
        btn.classList.remove('visible');
      }
    });
  }
});